var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ProjectUsersTagsManager", {
        attrs: { viewModel: _vm.projectUsersTagsManager },
        on: {
          "create-tag": _vm.handleCreateProjectUsersTagCommand,
          "delete-tag": _vm.handleDeleteProjectUsersTagCommand,
          "update-tag": _vm.handleUpdateProjectUsersTagCommand,
        },
      }),
      _vm._v(" "),
      _c("ProjectUsersFromStringBuilder", {
        attrs: { viewModel: _vm.projectUsersFromStringBuilder },
        on: { "create-project-users": _vm.handleCreateProjectUsersCommand },
      }),
      _vm._v(" "),
      _c("ProjectUserDeleter", {
        attrs: { viewModel: _vm.projectUserDeleter },
        on: {
          "delete-project-user": _vm.handleDeleteProjectUserCommand,
          "archive-project-user": _vm.handleArchiveProjectUserCommand,
        },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: _vm.url_ManageAssignmentsPage,
                      expression: "url_ManageAssignmentsPage",
                    },
                  ],
                  staticClass: "btn btn-outline-secondary",
                  staticStyle: { padding: "0.7em 2em" },
                },
                [_vm._v("Assign " + _vm._s(_vm.alternativesLabel))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: { click: _vm.showTagsManager },
                },
                [_vm._v("Manage tags")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: { click: _vm.showProjectUsersFromStringBuilder },
                },
                [_vm._v("Add")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        !_vm.initialized
          ? _c("h3", [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Loading... "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.initialized
          ? _c("div", [
              _c(
                "nav",
                {
                  staticClass:
                    "navbar navbar-light navbar-expand-md bg-light pl-1",
                  attrs: { role: "navigation" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "btn-group mr-auto",
                      attrs: { role: "group" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: {
                            "btn-secondary": !_vm.archivedFilter,
                            "btn-outline-secondary": _vm.archivedFilter,
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.archivedFilter = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Active\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: {
                            "btn-secondary": _vm.archivedFilter,
                            "btn-outline-secondary": !_vm.archivedFilter,
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.archivedFilter = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Archived\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control form-control-sm mr-sm-2",
                        attrs: { type: "search", placeholder: "Search" },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("form", { staticClass: "form-inline" }, [
                    _c("div", { staticClass: "dropdown" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary btn-sm dropdown-toggle",
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Filter by: " +
                                _vm._s(_vm.tagFilter ?? "Show all")
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.tagFilter = null
                                },
                              },
                            },
                            [_vm._v("Show all")]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("By tag:"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.tags, function (t) {
                            return _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    _vm.tagFilter = t
                                  },
                                },
                              },
                              [_vm._v(_vm._s(t))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("table", { staticClass: "table table-hover" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.projectUsersView, function (p) {
                    return _c("tr", { key: p.ProjectUserId }, [
                      _c("td", [
                        !p.Editing
                          ? _c("div", { staticClass: "d-flex flex-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "pointer",
                                  staticStyle: { width: "300px" },
                                  on: {
                                    click: function ($event) {
                                      return p.edit()
                                    },
                                  },
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(p.Name))]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    { staticClass: "text-muted text-nowrap" },
                                    [
                                      p.IsUserAccepted
                                        ? _c("span", {
                                            staticClass:
                                              "fa fa-user text-success",
                                            attrs: { title: "User" },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.IsUserRejected
                                        ? _c("span", {
                                            staticClass:
                                              "fa fa-user text-danger",
                                            attrs: {
                                              title: "User access rejected",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.IsUserRequested
                                        ? _c("span", {
                                            staticClass:
                                              "fa fa-user text-secondary",
                                            attrs: {
                                              title: "User access requested",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(p.Email || "No email")),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "pointer",
                                  on: {
                                    click: function ($event) {
                                      return p.edit()
                                    },
                                  },
                                },
                                _vm._l(p.Tags, function (t) {
                                  return _c(
                                    "span",
                                    {
                                      key: t,
                                      staticClass: "badge badge-secondary mr-1",
                                    },
                                    [_vm._v(_vm._s(t))]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml-auto" }, [
                                !p.IsArchived
                                  ? _c("div", { staticClass: "dropdown" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary dropdown-toggle",
                                          attrs: {
                                            type: "button",
                                            "data-toggle": "dropdown",
                                          },
                                        },
                                        [_vm._v("Actions")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu dropdown-menu-right",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return p.edit()
                                                },
                                              },
                                            },
                                            [_vm._v("Edit")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          !p.IsUserAccepted &&
                                          !p.IsUserRequested &&
                                          p.Email
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleRequestAccount(
                                                        p
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Request an account")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleResetProjectUserAccessTokenCommand(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Reset access links")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleArchiveProjectUserCommand(
                                                    p.ProjectUserId
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Archive")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showProjectUserDeleter(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Delete")]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                p.IsArchived
                                  ? _c("div", { staticClass: "dropdown" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary dropdown-toggle",
                                          attrs: {
                                            type: "button",
                                            "data-toggle": "dropdown",
                                          },
                                        },
                                        [_vm._v("Actions")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu dropdown-menu-right",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleUnarchiveProjectUserCommand(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Unarchive")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showProjectUserDeleter(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Delete")]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        p.Editing
                          ? _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("Name")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: p.NewName,
                                        expression: "p.NewName",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control input-sm",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Name",
                                    },
                                    domProps: { value: p.NewName },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          p,
                                          "NewName",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "error" }, [
                                    _vm._v(_vm._s(p.NameError)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("Email")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: p.NewEmail,
                                        expression: "p.NewEmail",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control input-sm",
                                    attrs: {
                                      type: "email",
                                      placeholder: "Email",
                                    },
                                    domProps: { value: p.NewEmail },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          p,
                                          "NewEmail",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "error" }, [
                                    _vm._v(_vm._s(p.EmailError)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("label", [_vm._v("Tags")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "dropdown d-inline-block" },
                                    [
                                      _vm._v(
                                        "\n                                        ("
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [_vm._v("add tag")]
                                      ),
                                      _vm._v(
                                        ")\n                                        "
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-menu" },
                                        _vm._l(_vm.tags, function (t) {
                                          return _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return p.addTag(t)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(t))]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm._l(p.NewTags, function (t) {
                                    return _c(
                                      "span",
                                      {
                                        key: t,
                                        staticClass:
                                          "badge badge-secondary pointer mr-2",
                                        attrs: { title: "remove a tag" },
                                        on: {
                                          click: function ($event) {
                                            return p.removeTag(t)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(t) + " ×")]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 text-right" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary btn-sm",
                                    attrs: { title: "confirm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleUpdateProjectUserCommand(
                                          p
                                        )
                                      },
                                    },
                                  },
                                  [_c("span", { staticClass: "fa fa-check" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary btn-sm",
                                    attrs: { title: "cancel" },
                                    on: {
                                      click: function ($event) {
                                        return p.cancelEdit()
                                      },
                                    },
                                  },
                                  [_c("span", { staticClass: "fa fa-times" })]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("People")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }